(function(){
    'use strict'

    angular.module('app.puestos')
    .factory('PuestosService', PuestosService);

    PuestosService.$inject = ['$http', '$q', 'apiSettings'];

    function PuestosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/puestos';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(puestoId){

            var url = apiSettings.apiBaseUrl + 'api/puestos/' + puestoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(puesto){

            puesto.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/puestos',  
                method: 'POST',  
                data: puesto
            });  
            return response;
        };

        function update(puesto){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/puestos',  
                method: 'PUT',  
                data: puesto
            });  
            return response;
        };

        function remove(puesto){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/puestos',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: puesto
            });  
            return response;
        };

    };

})();